import { ca } from '@cian/analytics';

const MORTGAGE_BUTTON_TRAP_EXTRA = {
  trap_type: 'cigar_get_offers_pvz',
  bannerName: 'Получить предложения банков',
  trapid: 'Получить предложения банков',
} as const;

const MORTGAGE_GOS_HELP_BUTTON_TRAP_EXTRA = {
  trap_type: 'cigar_gos_help_apply_online',
  bannerName: 'Подать заявку онлайн',
  trapid: 'Подать заявку онлайн',
} as const;

const MORTGAGE_HOW_WORKS_BUTTON_TRAP_EXTRA = {
  trap_type: 'cigar_how_works_apply_online',
  bannerName: 'Подать заявку онлайн',
  trapid: 'Подать заявку онлайн',
} as const;

export const MAINPAGE_MORTGAGE_BUTTON_HREF =
  '/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_button&cian_content=cigar_get_offers_pvz';

export const MAINPAGE_MORTGAGE_GOS_HELP_BUTTON_HREF =
  '/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_button&cian_content=cigar_gos_help_apply_online';

export const MAINPAGE_MORTGAGE_HOW_WORKS_BUTTON_HREF =
  '/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_button&cian_content=cigar_how_works_apply_online';

const getMortgageButtonTrapPage = () => ({
  extra: MORTGAGE_BUTTON_TRAP_EXTRA,
});

const getMortgageGosHelpButtonTrapPage = () => ({
  extra: MORTGAGE_GOS_HELP_BUTTON_TRAP_EXTRA,
});

const getMortgageHowWorksButtonTrapPage = () => ({
  extra: MORTGAGE_HOW_WORKS_BUTTON_TRAP_EXTRA,
});

export const trackMainpageMortgageButtonShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'mortgage_button',
    page: getMortgageButtonTrapPage(),
  });
};

export const trackMainpageMortgageButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'mortgage_button',
    page: getMortgageButtonTrapPage(),
  });
};

export const trackMainpageMortgageGosHelpButtonShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'mortgage_button',
    page: getMortgageGosHelpButtonTrapPage(),
  });
};

export const trackMainpageMortgageGosHelpButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'mortgage_button',
    page: getMortgageGosHelpButtonTrapPage(),
  });
};

export const trackMainpageMortgageHowWorksButtonShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'mortgage_button',
    page: getMortgageHowWorksButtonTrapPage(),
  });
};

export const trackMainpageMortgageHowWorksButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'mortgage_button',
    page: getMortgageHowWorksButtonTrapPage(),
  });
};
